import axios from 'axios';
import { setupAuthInterceptor } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.management_api.locales;

// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));



// GetLocalByLocalId
export const getLocalByLocalId = async (localId: string) => {

  return await api.get(`/GetLocalByLocalId/${localId}`);
};

//crea un local
export const CreateLocal = async (LocalData: any) => {
  return await api.post('/CreateLocal', LocalData);
};


//crea un local en regustration
export const CreateLocalRegistration = async (LocalData: any) => {
  return await api.post('/CreateLocalRegistration', LocalData);
};


export const DeleteLocalRegistration = async (code: string) => {
    return await api.delete(`/DeleteLocalRegistration/${code}`);
}

export const GetAllLocals = async () => {
    return await api.get('/GetAllLocals');
}

export const DeleteLocalPermanently = async (localId: number) => {
    return await api.delete(`/DeleteLocalPermanently/${localId}`);
}

/**
 * @ns.route('/ToggleLocalState/<int:local_id>')
@ns.param('local_id', 'The unique identifier of the local to toggle')
class ToggleLocalState(Resource):
    @ns.doc('toggle_local_state', security='bearerAuth')
    @jwt_required()
    def put(self, local_id):
        '''
        ADMIN ONLY: Toggle the state of a local and all its users.
        
        If local is active (state=True), it will be deactivated (state=False) along with all users.
        If local is inactive (state=False), it will be activated (state=True) along with all users.
        '''
        # Check if user is admin
        claims = get_jwt()
        identity = claims.get('sub', {})
        is_admin = identity.get('is_admin', False)
        
        if not is_admin:
            ns.abort(403, 'Unauthorized: Only admin users can toggle local state')
        
        # Verify local exists
        local = Local.query.get(local_id)
        if not local:
            ns.abort(404, f'Local with ID {local_id} not found')
        
        # Toggle the state
        old_state = local.state
        new_state = not old_state
        
        # Update local state
        local.state = new_state
        
        # Update all users of this local
        users_updated = User.query.filter_by(local_id=local_id).update(
            {'state': new_state},
            synchronize_session='fetch'
        )
        
        db.session.commit()
        
        return {
            'message': f'Local {local_id} ({local.local_name}) has been {"activated" if new_state else "deactivated"}',
            'local_id': local_id,
            'local_name': local.local_name,
            'old_state': old_state,
            'new_state': new_state,
            'users_updated': users_updated
        }, 200
 */

export const ToggleLocalState = async (localId: number) => {
    return await api.put(`/ToggleLocalState/${localId}`);
} 